<template>
  <div class="charge-type app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>收费类型名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入收费类型名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newChargeType()">新增收费类型</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="state" slot-scope="text, data">
        <a-switch :disabled="!!data.is_default" :checked="data.is_show === 1" :loading="data.stateLoading" @click="stateChange(data)"></a-switch>
      </template>
      <template slot="action" slot-scope="text, data" v-if="!data.is_default">
        <a-space>
          <a-button type="link" @click="editChargeType(data)">编辑</a-button>
          <a-button type="link" @click="deleteChargeType(data)">删除</a-button>
        </a-space>
      </template>
    </a-table>
    <a-modal :title="addModal.title" :confirm-loading="addModal.loading" v-model="addModal.show" @ok="confirmAddModal" destroy-on-close centered>
      <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
        <a-form-model-item label="收费类型名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入收费类型名称" allow-clear></a-input>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="note">
          <a-textarea v-model="form.note" placeholder="请输入备注"></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal :title="editModal.title" :confirm-loading="editModal.loading" v-model="editModal.show" @ok="confirmEditModal" destroy-on-close centered>
      <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
        <a-form-model-item label="收费类型名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入收费类型名称" allow-clear></a-input>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="note">
          <a-textarea v-model="form.note" placeholder="请输入备注"></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import ChargeTypeService from '@/io/charge_type.js';

  export default {
    name: 'ChargeType',
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            name: null
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '收费类型名称',
              dataIndex: 'name'
            },
            {
              title: '备注',
              dataIndex: 'remark'
            },
            {
              title: '状态',
              scopedSlots: { customRender: 'state' }
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        form: {
          name: null,
          note: null
        },
        rules: {
          name: [
            {
              required: true,
              message: '请填写收费类型名称'
            }
          ],
          note: [
            {
              required: true,
              message: '请填写备注'
            }
          ]
        },
        addModal: {
          id: null,
          title: '新增收费类型',
          show: false,
          loading: false
        },
        editModal: {
          id: null,
          title: '编辑收费类型',
          show: false,
          loading: false
        },
      }
    },
    mounted () {
      this.initData();
    },
    methods: {
      stateChange(data) {
        let checked = data.is_show === 1;
        data.stateLoading = true;
        ChargeTypeService.switchStatus(data.id).then(res => {}).catch(err => {}).finally(() => {
          this.$afterFormSubmit(checked ? '关闭成功' : '开启成功');
          data.is_show = checked ? 0 : 1;
          data.stateLoading = false;
        });
      },
      editChargeType(data) {
        this.form.name = data.name;
        this.form.note = data.remark;
        this.editModal.id = data.id;
        this.editModal.show = true;
      },
      confirmEditModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.editModal.loading = true;
          ChargeTypeService.edit(this.editModal.id, this.form.name, this.form.note).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              this.initData(res);
            });
          }).catch(err => {}).finally(() => {
            this.editModal.show = false;
            this.editModal.loading = false;
          });
        });
      },
      deleteChargeType(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此收费类型？',
          onOk() {
            ChargeTypeService.del(data.id).then(res => {
              self.initData();
            }).catch(err => {});
          }
        });
      },
      newChargeType() {
        this.form.name = null;
        this.form.note = null;
        this.addModal.show = true;
      },
      confirmAddModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.addModal.loading = true;
          ChargeTypeService.add(this.form.name, this.form.note).then(res => {
            this.$afterFormSubmit('创建成功', () => {
              this.initData(res);
            });
          }).catch(err => {}).finally(() => {
            this.addModal.show = false;
            this.addModal.loading = false;
          });
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        return ChargeTypeService.listPage(
          this.table.search.name,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.stateLoading = false;
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
    },
  }
</script>

<style lang="less" scoped>

</style>